module.exports = __webpack_public_path__ + "img/imageTooltipExample.49ebef0b.svg";